module.exports = __webpack_public_path__ + "img/edit-ic.c885ec12.svg";